import { Image } from '@skooldio/skooldio-ui-components-core';

export default Image;
